module.exports = __webpack_public_path__ + "img/Idea applications_Outline.d37645ec.png";